import { type ISchema } from 'yup';
import { yup } from './initYup.ts';

/**
 * Shortcut per gestire il tipo di un arraySchema
 */
export type YupArraySchema<T, C = any> = yup.ArraySchema<T[], C, T[], 'd'>;

/**
 * Riconosce se uno schema è di tipo array
 */
export function isYupArraySchema(
  schema: ISchema<any>,
): schema is YupArraySchema<any> {
  return schema instanceof yup.Schema && schema.type === 'array';
}
